import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MtxDialogData } from '@ng-matero/extensions';
import { ChargerService } from 'app/shared/services/charger/charger.service';
import { DateService } from 'app/shared/services/utility/date.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MouseEvent } from '@agm/core';
import {AgmMap,MapsAPILoader  } from '@agm/core';  
import{GeoLocationService} from 'app/shared/services/map/geo-location.service'
import * as _moment from 'moment';
import {ViewEncapsulation} from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
// tslint:disable-next-line:no-duplicate-imports

interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
}


@Component({
  selector: 'app-map-dialog',
  templateUrl: './map-dialog.component.html',
  styleUrls: ['./map-dialog.component.scss'],
  providers:[GeoLocationService],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class MapDialogComponent implements OnInit {
  @ViewChild(AgmMap,{static: true}) public agmMap: AgmMap;  
  params: any;
  isEditMode = false;
  form: FormGroup;
  localStorage : any;
  status = false;
  lat: number = 23.6330101;
  lng: number = 83.6902901;
  radius = 50;
  zoom: number = 8;
  openedWindow : number = 0; // alternative: array of numbers
  markers: marker[]= [
   
  ];
  //markers: Marker[];
  mLat: any;
  mLong:any;
  getAddress:any;
  coordinates;
  //apiloader:any;
  constructor(private fb: FormBuilder,
   private chargerService : ChargerService,
    private dateService : DateService,
    private snackBar: MatSnackBar,private apiloader: MapsAPILoader,
    public dialogRef: MatDialogRef<MapDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: MtxDialogData,public geoLocationService:GeoLocationService) {}

  ngOnInit() {
    this.initialize();
    
  
  }

  initialize(){

    this.localStorage = JSON.parse( localStorage.getItem('userDetails'));

    this.params = this.data;
    
    // this.isEditMode = this.params.action == 'CREATE' ? false : true;
    this.setCurrentLocation();
    
  }
  private setCurrentLocation() {
    this.geoLocationService.getPosition().subscribe(
      (pos: any) => {
        this.mLat = +(pos.coords.latitude);
        this.mLong = +(pos.coords.longitude); 
        this.zoom = 11;
         
      });
    
  }

  onNoClick() {
    this.dialogRef.close();
  }
  close() {

    this.dialogRef.close();
  }

  
 
  clickedMarker(label: string, index: number) {
  }
  
  mapClicked($event: MouseEvent) {
    this.markers = [];
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: false,
    });
 
    this.mLat = $event.coords.lat;
    this.mLong = $event.coords.lng;
  }
  
  markerDragEnd(m: marker, $event: MouseEvent) {
  }
  mapLatLong(){
    
   this.dialogRef.afterClosed().subscribe(res => {
     
    })
    this.dialogRef.close(this.markers);
   
  }
  
}






